// Animates one per line
const titleClasses = [
  ".hero__title p",
  ".hero-slider__title p", 
  ".featured-collection__heading",
  ".collage__title",
  ".about-wogan__heading p",
  ".text-banner__heading",
  ".banner__heading",
  
];

// Animates in block
const contentClasses = [
  ".hero__text", 
  ".hero__button",
  ".featured-collection__subtitle",
  ".collage__heading",
  ".collage__text",
  ".c-button",
  ".banner__text",
  ".about-wogan__paragraph",
  ".hero-slider__text", 
  ".text-banner__paragraph",
  ".product-card__header",
  ".product-card__flavour-notes",
  ".product-card__footer",
  ".product-card__media",
  ".about-wogan__graphic svg",
  ".text-banner__image img",
  ".c-footer__heading",
  ".reviews__rating",
  ".reviews__carousel-container",
  ".collage__item",
];

document.addEventListener('DOMContentLoaded', function () {
   setTimeout(() => { 
    titleClasses.forEach((textClass) => {
      const textElements = document.querySelectorAll(textClass);
      let strongWords = new Set();


      // SplitText only works with plain text. This is a workaround to make it work with <strong> tags
      // Removes <strong> tags before splitting text
      textElements.forEach(element => {
        let htmlContent = element.innerHTML;
        htmlContent = htmlContent.replace(/<strong>(.*?)<\/strong>/g, (match, p1) => {
            const words = p1.split(/\s+/); // Split the words
            words.forEach(word => {
                strongWords.add(word); // Add each word to the Set
            });
            return p1; // Replace <strong> tag with the word itself
        });
        element.innerHTML = htmlContent;
      });

      if (!textElements.length) {
        return; // If no elements found, exit the loop
      }
      
      textElements.forEach((textElement) => {
        textElement.style.opacity = "1";
      });
    
      textElements.forEach((textElement) => {
        const splitText = new SplitText(textElement, { type: "lines", linesClass: "line" });
    
        // Adds again <strong> after splitting text
        splitText.lines.forEach(div => {
            let words = div.textContent.split(/\s+/); // Split the text into words
            div.innerHTML = words.map(word => {
                if (strongWords.has(word)) {
                    return `<strong>${word}</strong>`; // Add <strong> tags if the word is in strongWords
                } else {
                    return word;
                }
            }).join(' ');
        });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: textElement,
            start: "top bottom-=100", // Animation starts when the top of the element reaches the bottom of the viewport
            end: "+=100",
            scrub: false,
            immediateRender: false,
            toggleActions: "restart none none none",
          },
        });
    
        splitText.lines.forEach((line, index) => {
          tl.fromTo(
            line,
            { opacity: 0, y: 20,  duration: 0.25 },
            { opacity: 1, y: 0, duration: 0.25 }
          );
        });

        // Manually trigger the animation for elements already in view
        if (textElement.getBoundingClientRect().top <= window.innerHeight) {
          tl.play();
        }
      });
    });

    contentClasses.forEach((textClass) => {
      const textElements = document.querySelectorAll(textClass);

      if (!textElements.length) {
        return; // If no elements found, exit the loop
      }
    
      textElements.forEach((textElement) => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: textElement,
            start: "top bottom-=100", // Animation starts when the top of the element reaches the bottom of the viewport
            end: "+=100",
            scrub: false,
            immediateRender: false,
            toggleActions: "restart none none none",
          },
        });
    
        tl.fromTo(
          textElement,
          { opacity: 0, y: 20, duration: 0.5 },
          { opacity: 1, y: 0, duration: 0.5 }
        );

        // Manually trigger the animation for elements already in view
        if (textElement.getBoundingClientRect().top <= window.innerHeight) {
          tl.play();
        }
      });
    });

  }, 500)
});
